import React from "react";

const ActionDropdown = ({
  doc,
  handleOpenModal,
  handleOpenSummaryModal,
  handleOpenFormOffcanvas,
  handleOpenDetailsOffcanvas,
}) => {
  return (
    <div className="action-dropdown">
      <button
        className="action-button"
        type="button"
        data-bs-toggle="dropdown"
      >
        <i className="bi bi-three-dots-vertical"></i>
      </button>

      <ul className="dropdown-menu dropdown-menu-end modern-dropdown">
        <li>
          <button className="dropdown-item" onClick={() => handleOpenModal(doc)}>
            <i className="bi bi-tag" />
            <span>Add Tag</span>
          </button>
        </li>

        <li>
          <button
            className="dropdown-item"
            onClick={() => handleOpenSummaryModal(doc)}
          >
            <i className="bi bi-file-text" />
            <span>Summary</span>
          </button>
        </li>

        <li>
          <button
            className="dropdown-item"
            onClick={() => handleOpenFormOffcanvas(doc)}
          >
            <i className="bi bi-pencil" />
            <span>{doc.hasDetails ? "Edit" : "Add"} Details</span>
          </button>
        </li>

        <li>
          <button
            className="dropdown-item"
            onClick={() => handleOpenDetailsOffcanvas(doc)}
          >
            <i className="bi bi-eye" />
            <span>View Details</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ActionDropdown;
